export const HASHTAG_SEARCH_URL = 'https://displaypurposes.com/';
